import { createAction } from 'redux-act'

// ----------------------------------------
// FETCH NOTIFICATIONS
// ----------------------------------------
export const fetchNotificationsStart = createAction('inbox - fetch notifications start')

export const fetchNotificationsSuccess = createAction<any>('inbox - fetch notifications success')

export const fetchNotificationsFail = createAction<any>('inbox - fetch notifications fail')

// ----------------------------------------
// MARKING NOTIFICATIONS
// ----------------------------------------

export const markAsRead = createAction<any>('inbox - mark as read')

export const allMessagesRead = createAction('inbox - all messages read')

// ----------------------------------------
// TOGGLE MODAL
// ----------------------------------------

export const toggleInbox = createAction('inbox - toggle inbox')

export default {
  fetchNotificationsStart,
  fetchNotificationsSuccess,
  fetchNotificationsFail,
  allMessagesRead,
  toggleInbox,
}
